import {createBrowserHistory} from 'history';
export default createBrowserHistory();

export function logout () {
    localStorage.clear() ;
    createBrowserHistory().go("/authentication/sign-in/illustration"); 

}
